export class NumericDistribution {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mean",
            "baseName": "mean",
            "type": "number",
            "format": "double"
        },
        {
            "name": "std",
            "baseName": "std",
            "type": "number",
            "format": "double"
        },
        {
            "name": "min",
            "baseName": "min",
            "type": "number",
            "format": "double"
        },
        {
            "name": "p50",
            "baseName": "p50",
            "type": "number",
            "format": "double"
        },
        {
            "name": "p95",
            "baseName": "p95",
            "type": "number",
            "format": "double"
        },
        {
            "name": "max",
            "baseName": "max",
            "type": "number",
            "format": "double"
        },
        {
            "name": "quantiles",
            "baseName": "quantiles",
            "type": "Array<QuantilePoint>",
            "format": ""
        },
        {
            "name": "baseline",
            "baseName": "baseline",
            "type": "GaussianFit",
            "format": ""
        },
        {
            "name": "current",
            "baseName": "current",
            "type": "GaussianFit",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NumericDistribution.attributeTypeMap;
    }
    constructor() {
    }
}
